import {CHANGE_MENU, REST_MENU, SET_MENU, REMOVE_MENU} from "./types";
const actions = {
    changeMenu: ({commit}, menus) => {
        commit(CHANGE_MENU, menus)
    },
    setMenu: ({commit}, menus) => {
        commit(SET_MENU, menus)
    },
    restMenu: ({commit}, _) => {
        commit(REST_MENU)
    },
    removeMenu: ({commit}, _) => {
        commit(REMOVE_MENU)
    }
}
export default actions